import Box from '@mui/material/Box';
import { useI18n } from '../i18n';

// Interruptor ES/EN compacto. Vive fuera de Layout porque NoAccess no monta
// la barra superior y ahí también hace falta poder cambiar de idioma.
export default function LanguageToggle({ sx }) {
  const { t, lang, setLang, languages } = useI18n();

  return (
    <Box role="group" aria-label={t('lang.switch')} sx={{
      display: 'inline-flex', border: '1px solid #E4E0E2',
      borderRadius: '4px', overflow: 'hidden', ...sx,
    }}>
      {languages.map((l) => (
        <Box
          key={l.code}
          component="button"
          type="button"
          onClick={() => setLang(l.code)}
          aria-label={l.label}
          aria-pressed={lang === l.code}
          sx={{
            border: 'none', cursor: 'pointer', fontFamily: 'inherit',
            px: 1.1, py: '5px', fontSize: 11, fontWeight: 600, letterSpacing: '0.06em',
            backgroundColor: lang === l.code ? '#FFF0F0' : '#fff',
            color: lang === l.code ? '#FF6666' : '#847782',
          }}
        >
          {l.code.toUpperCase()}
        </Box>
      ))}
    </Box>
  );
}
